module.exports = "- Use functional refs: `ref={ (el) => { this._root = el; }`\n"